import { RoutingLink } from "#src/batteries-included-components/RoutingLink";
import { linkToUserDetailPage } from "#src/routes/settings/users/detail";
import {
  Chip,
  Skeleton,
  type DataDisplayProps,
} from "@validereinc/common-components";
import type { UserType } from "@validereinc/domain";
import { getNameAbbreviation } from "@validereinc/utilities";
import React from "react";

export type UserDataDisplayProps = Pick<UserType, "name" | "id"> &
  Pick<DataDisplayProps, "isLoading" | "isBusy" | "isInline" | "alignment"> & {
    sizeVariant?: "small" | "medium";
  };

export const UserDataDisplay = ({
  id,
  name,
  sizeVariant = "medium",
  alignment = "left",
  isInline,
  isLoading,
  isBusy,
}: UserDataDisplayProps) => {
  return (
    <div
      aria-label="User details"
      style={{
        display: isInline ? "inline-flex" : "flex",
        alignItems: isInline ? "baseline" : "center",
        justifyContent:
          alignment === "justified"
            ? "center"
            : alignment === "right"
              ? "flex-end"
              : "flex-start",
      }}
    >
      {!isInline ? (
        <Chip
          text={getNameAbbreviation(name) ?? ""}
          tooltipText={name}
          style={{
            marginRight: 4,
            padding: sizeVariant === "medium" ? 4 : 2,
            alignSelf: isInline ? "baseline" : "center",
            ...(sizeVariant === "small" ? { minWidth: 22 } : {}),
          }}
          shapeVariant="circle"
          isLoading={isLoading}
          isBusy={isBusy}
        />
      ) : null}
      <Skeleton
        isLoading={isLoading}
        isBusy={isBusy}
      >
        {id ? (
          <RoutingLink
            to={linkToUserDetailPage(id)}
            variant={isInline ? "secondary" : "primary"}
          >
            {name}
          </RoutingLink>
        ) : (
          name
        )}
      </Skeleton>
    </div>
  );
};
